import React from 'react';
import backgroundImage from '../image_dir/BACKGROUND.png';

/*
 * FeaturesSection lists the core capabilities of wisyguide.  The list
 * sits atop a semi‑transparent overlay on top of a supplied background
 * image (for example, a stock photo of a support agent).  Each bullet
 * succinctly summarises a benefit of the platform.
 */
function FeaturesSection() {
  const features = [
    'Estrae e memorizza informazioni direttamente dai tuoi pdf;',
    'Semplifica il lavoro del team fornendo risposte che sfruttano tutte le fonti aziendali;',
    'Velocizza le risposte preparando email al posto degli operatori;',
    'Traccia gli interventi aperti e genera metriche di performance;',
    'Risponde in 80 lingue diverse;',
    'Nessuna perdita di Know‑How aziendale causata da turn‑over del personale.'
  ];

  return (
    <section
      className="features-section"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <div className="overlay">
        <ul>
          {features.map((feature, index) => (
            <li key={index}>{feature}</li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default FeaturesSection;